import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface ExportCandidatesPayload {
  assessment_id: string;
  columns: string[];
  response_ids?: number[];
}

export const useExportCandidates = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: ExportCandidatesPayload) => {
      const response = await apiClient.post(
        '/candidate/dashboard/export/',
        payload,
        { responseType: 'blob' }
      );
      return response.data as Blob;
    },
    onSuccess: (blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'candidates.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.message || error.message || 'Failed to export candidates';
      openToast({
        show: true,
        heading: 'Error',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};
